import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import type { IColumn } from 'shared/ui/TableNew/store/types'
import { Typography } from 'shared/ui'
import { type WebhookRow } from 'entities/Webhook'
import { type IntegrationWebhooksStore } from 'pages/settings/pages/integrations/pages/Webhooks/store/IntegrationWebhooksStore'
import { WebhookStatus } from 'pages/settings/pages/integrations/pages/Webhooks/ui/WebhookStatus/WebhookStatus'
import styles from './styles.module.scss'

type WebhooksTableProps = {
  store: IntegrationWebhooksStore
}

export const WebhooksTable = observer(({ store }: WebhooksTableProps) => {
  const rows = useMemo(() => store.webhooksRows, [store.webhooksRows])

  const columns: IColumn<WebhookRow>[] = useMemo(
    () => [
      {
        field: 'name',
        name: 'Name',
        width: '170px',
        maxWidth: 170,
      },
      {
        field: 'status',
        name: 'Status',
        width: '130px',
        renderRowCell: (row) => <WebhookStatus isActive={row.status} />,
      },
      {
        field: 'url',
        name: 'URL',
        width: '390px',
        renderRowCell: (row) => (
          <Typography
            ariaLabel='url'
            color='var(--content-primary-tertiary)'
            variant='body-sm-regular'
            tooltipProps={{
              title: row.url,
            }}
          >
            {row.url}
          </Typography>
        ),
      },
    ],
    []
  )

  return (
    <div className={styles.root}>
      <div className={styles.table}>
        <Table
          ariaLabel={'WebhooksTable'}
          columns={columns}
          rows={rows}
          store={store.tableStore}
          height='100%'
          emptyStateProps={{
            text: "You don't have any webhooks added yet",
            noIcon: true,
          }}
          onRowClick={store.onRowClick}
        />
      </div>
    </div>
  )
})
